import { useEffect, useState, useSyncExternalStore } from "react";
import { currentPending, pendingWords, subscribePending, undoPending } from "../lib/pendingSend";
import { href } from "../lib/route";

/* THE UNDO THAT FOLLOWS THE COACH (W82 step 4, Fable's bound): drawn at the app's level, so a review sent and then left by
 * reflex (Skip, ← / →, any link) keeps its `Undo` on the next page for the seconds that remain. Nothing when nothing waits. */
export function PendingSendToast() {
  const pending = useSyncExternalStore(subscribePending, currentPending, currentPending);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (pending === null) return;
    const t = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(t);
  }, [pending]);
  if (pending === null) return null;
  // On the review that owns the send, its own card carries the Undo — one Undo on screen, never two.
  if (window.location.hash.startsWith(href({ name: "review", sessionId: pending.key }))) return null;
  return (
    <div className="pending-toast" role="status" aria-live="polite">
      <span>{pendingWords(pending, now)}</span>
      <button type="button" className="ht-button ht-button-quiet pending-undo" onClick={() => { undoPending(pending.key); }}>Undo</button>
    </div>
  );
}
